const subscriptionPlansDanish = {
  header: {
    title: "Vælg din plan",
    description: "Få adgang til alle funktioner og start med at øge din LinkedIn præsens i dag."
  },
  trial: {
    title: "14 dages gratis prøveperiode",
    subtitle: "Ingen binding - opsig når som helst"
  },
  billing: {
    monthly: "Månedligt",
    yearly: "Årligt",
    savingsLabel: "Spar 17%"
  },
  currency: {
    dkk: "DKK",
    usd: "USD"
  },
  plans: {
    basic: "Basic"
  },
  pricing: {
    perMonth: "måned",
    perYear: "år",
    monthly: "måned",
    yearly: "år"
  },
  quantity: {
    label: "Antal licenser:",
    seatsInfo: "Hver licens giver adgang til 1 bruger"
  },
  summary: {
    total: "Total:",
    checkoutButton: "Start gratis prøveperiode"
  },
  errors: {
    checkoutError: "Der opstod en fejl ved oprettelse af checkout session. Prøv igen senere."
  }
};

export default subscriptionPlansDanish;
